<template>
    <div
        class="o-d-search search"
    >
        <ODMenuHeader
            :title="$t('ui.mobile-search-title')"
            :subtitle="$t('ui.mobile-search-subtitle')"
        />
        <MSearchbar
            v-model="value"
            @onBlur="handleBlur"
            @onClear="handleClear"
        >
            <template #icon-befor>
                <div class="search-icon" >
                    <svg-icon
                        original
                        name="icons/search_mobile"
                    />
                </div>
            </template>
        </MSearchbar>
        <div
            class="search__searchresults"
        >
            <OSearchresult
                :items="defineItems"
                :placeholders="placeholders"
                :hasStrictResult="hasStrictResult"
                :is-nomatches-show="!!value"
                @onSearchTileClick="handleSearchTileClick"
            />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import MSearchbar from '../../molecules/m-searchbar/m-searchbar';
import OSearchresult from '../../organisms/o-searchresult/o-searchresult';
import ODMenuHeader from '../../organisms/o-d-menu-header/o-d-menu-header';

import search from '../../../utils/mixins/search';
import {
    WEB_GUIDE,
    WEB_SERVICE
} from '../../../utils/constants/pages';

import {SUCCESS_SEARCH} from '../../../utils/constants/bus-events-constants'

export default {
    name: 'ODStart',
    components: {
        MSearchbar,
        ODMenuHeader,
        OSearchresult,
    },
    data() {
        return {
            placeholders: null,
            isNomatchesShow: false
        }
    },
    mixins: [search],
    computed: {
        defineItems() {
            // TODO: replace with arr generator
            const placeholders = [{}, {}, {}, {}, {}, {}, {}, {}];
            return this.placeholders ? placeholders : this.getItems
        }
    },
    methods: {
        handleBlur(val) {
            setTimeout(() => {
                this.inputFocus = val;
            }, 500)
        },
        handleMenuClick(data) {
            const params = {
                name: `web.${data}`
            };
            this.$router.push(params);
        },
        handleSearchTileClick(data) {
            this.$bus.$emit(SUCCESS_SEARCH, {
                value1: this.value,
                value2: "found",
                value3: "request_guide",
                target: 'object',
                target_type: data.type,
                target_id: data.id,
            })
            const params = {
                name: WEB_GUIDE,
                params: {
                    type: 'search'
                },
                query: {
                    to: data.id
                }
            };
            this.$router.push(params);
            // if (data.type === 'tenant') {
            //     const params = {
            //         name: WEB_GUIDE,
            //         params: {
            //             type: 'start'
            //         },
            //         query: {
            //             to: data.id
            //         }
            //     };
            //     this.$router.push(params);
            // } else if (data.type === 'service') {
            //     const params = {
            //         name: WEB_GUIDE,
            //         params: {
            //             type: 'services'
            //         },
            //         query: {
            //             to: data.id
            //         }
            //     };
            //     this.$router.push(params);
            // } else {
            //     const params = {
            //         name: WEB_SERVICE,
            //         query: {
            //             id: data.id
            //         }
            //     };
            //     this.$router.push(params);
            // }
        }
    }
}
</script>

<style lang="scss">
@import "o-d-search";
</style>
